import Vue from 'vue';  
export const EventLogin = new Vue();

